// removed by extract-text-webpack-plugin
module.exports = {"component":"_2mWP4prBMFS7UlmTceAb_V"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Hotsite/theme.css
// module id = 1237
// module chunks = 2